import { hotRanking, watchNotes } from "@/mocks/homeNews";
import { SectionHead, Tag } from "./bits";

export default function HotRanking() {
  return (
    <section id="rebang" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          {/* 热榜榜单 */}
          <div className="lg:col-span-8">
            <SectionHead eyebrow="热度上升中" title="猛料热榜" desc="按阅读与讨论热度实时排序，今天的瓜都在这一屏。"/>
            <div className="flex flex-col gap-3">
              {hotRanking.map((s, i) => (
                <a
                  key={s.id}
                  href="#faq"
                  className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 transition-colors hover:border-primary-300 hover:bg-background-100 cursor-pointer"
                >
                  <span
                    className={`w-9 h-9 shrink-0 rounded-md flex items-center justify-center font-heading text-lg font-black ${
                      i < 3 ? "bg-primary-600 text-background-50" : "bg-secondary-100 text-foreground-700"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm md:text-[15px] font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                      {s.title}
                    </p>
                    <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-600">
                      <span className="whitespace-nowrap">{s.time}</span>
                      <span className="inline-flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                        {s.reads}
                      </span>
                    </div>
                  </div>
                  <div className="hidden sm:flex flex-col items-center gap-1 shrink-0">
                    <span className="text-sm font-bold text-accent-600">{s.hot}</span>
                    <span className="text-[10px] text-foreground-500 whitespace-nowrap">热度分</span>
                  </div>
                  <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center text-foreground-400 group-hover:text-primary-500 transition-colors" />
                </a>
              ))}
            </div>
          </div>

          {/* 追更小报 */}
          <aside className="lg:col-span-4 flex flex-col gap-5">
            <div className="rounded-lg bg-accent-500 text-background-50 p-5">
              <div className="flex items-center gap-2 mb-1">
                <i className="ri-notification-3-fill w-5 h-5 flex items-center justify-center" />
                <span className="text-sm font-bold tracking-widest">你关注的追更小报</span>
              </div>
              <p className="text-xs text-background-50/85 mb-4">为想抢在别人之前吃瓜的你，单独划重点。</p>
              <ul className="flex flex-col gap-3">
                {watchNotes.map((n, i) => (
                  <li key={i} className="flex items-start gap-2 text-[13px] leading-snug text-background-50/95">
                    <span className="mt-0.5 w-1.5 h-1.5 shrink-0 rounded-full bg-background-50" />
                    {n}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
              <span className="text-xs font-bold tracking-[0.18em] text-primary-600">今日热搜词</span>
              <div className="mt-3 flex flex-wrap gap-2">
                <Tag label="# 某顶流饭局" tone="primary" />
                <Tag label="# 选秀回归" tone="secondary" />
                <Tag label="# 全网最低价" tone="accent" />
                <Tag label="# 番位海报" tone="secondary" />
                <Tag label="# 双综撞档" tone="accent" />
                <Tag label="# 直播秒空" tone="primary" />
              </div>
              <p className="mt-4 text-xs text-foreground-600 leading-relaxed">
                上榜即代表今日讨论量骤增，想抢在别人之前吃瓜，先把这些词条点开看完。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}